import BackendDeveloperPage from "./BackendDeveloperPage";

export default function RubyOnRailsDeveloperPage() {
  return <BackendDeveloperPage technology="ruby_on_rails" />;
}
